import React, { useState } from "react";
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { setFormModal } from "../redux/slices/modalSlice";

const StudentEventDetails = () => {
  const dispatch = useDispatch();
  const [error,] = useState("");
  const errorsArray = Array.isArray(error) ? error : [error];
  const eventDetailsData = useSelector((state) => state?.event?.eventDetails);

   const handleRegisterEvent = (item) => {
     dispatch(setFormModal({ status: true, title: "Registration Form", type: "EventReg", size: "md" }));
   }

  const list = [
    { title: "Description:", description: eventDetailsData?.description },
    {
      title: "Start Date:",
      description:
        eventDetailsData?.startDate &&
        format(new Date(eventDetailsData?.startDate), "yyyy-MM-dd"),
    },
    {
      title: "End Date:",
      description:
        eventDetailsData?.endDate &&
        format(new Date(eventDetailsData?.endDate), "yyyy-MM-dd"),
    },
    {
      title: "Registration Link:",
      description: eventDetailsData?.registrationLink,
    },
    { title: "Guest Speaker:", description: eventDetailsData?.guestSpeaker },
    { title: "Event Location:", description: eventDetailsData?.eventLocation },
    { title: "Status:", description: eventDetailsData?.status },
  ];
  return (
    <>
      {error && (
        <Alert status="error" className="mt-3" mb={3}>
          <AlertIcon />
          <AlertTitle>{errorsArray.join(", ")}</AlertTitle>
        </Alert>
      )}
      <Box bgColor={"white"} h={"100%"}>
        <Flex
          justifyContent={"flex-start"}
          pl={"50px"}
          alignItems={"center"}
          mx={"-24px"}
          h={"80px"}
          bgColor={"#EFC3CD"}
          mb={"30px"}
        >
          <Text
            color={"#D11A2A"}
            fontSize={["18px", "20px", "24px"]}
            fontWeight={"600"}
            pl={["2px", null, null]}
          >
            {eventDetailsData?.eventName}
          </Text>
        </Flex>
        {list?.map((item, index) => (
          <Flex
            key={index}
            alignItems={"center"}
            px={["", "15px", "20px"]}
            pb={5}
            gap={["3", null, null]}
          >
            <Text
              color={"rgba(81, 81, 101, 0.5)"}
              fontSize={"16px"}
              fontWeight={700}
              w={["40%", "10%", "15%"]}
            >
              {item.title}
            </Text>
            <Text
              color={"rgba(0, 0, 0, 0.5)"}
              fontSize={"14px"}
              fontWeight={700}
              w={["70%", "100%", "85%"]}
            >
              {item.description}
            </Text>
          </Flex>
        ))}{" "}
      </Box>
      <Flex justifyContent={"left"} alignItems={"center"} gap={5}>
        <Button
          mt={10}
          fontSize={"16px"}
          fontWeight={"500"}
          lineHeight={"16px"}
          width={"200px"}
          background={"#A6A6A6"}
          _hover={{ background: " " }}
          color={"#FFFFFF"}
        //   onClick={() => {
        //     navigate("/usermanagement/users");
        //   }}
        >
          Cancel
        </Button>
        <Button
          mt={10}
          fontSize={"16px"}
          fontWeight={"500"}
          lineHeight={"16px"}
          width={"200px"}
        //   size={"lg"}
          background={"#D11A2A"}
          _hover={{ background: " " }}
          color={"#FFFFFF"}
          type="submit"
        //   isLoading={loading}
          loadingText="Saving ..."
          onClick={() => handleRegisterEvent()}
        >
          Register For Event
        </Button>
      </Flex>
    </>
  );
};

export default StudentEventDetails;
